/*
XOL-596 (readable read-only remarks): does a remarks value say anything?

An emptied quill editor stores `<p><br></p>` (truthy), so "is there text" asks the
text, not the string: any visible text, or an image, counts. Pure, so both the
RequestMixins method (`hasRemarksText`) and the ReadOnlyRemarks atom share it.
ES5, no optional chaining or nullish coalescing.
*/

export function hasRemarksText (html) {
  if (html === null || html === undefined || html === '') {
    return false
  }

  var source = String(html)

  if (/<img\b/i.test(source)) {
    return true
  }

  var text

  if (typeof DOMParser !== 'undefined') {
    var doc = new DOMParser().parseFromString(source, 'text/html')

    text = doc && doc.body ? doc.body.textContent : ''
  } else {
    text = source.replace(/<[^>]*>/g, ' ')
  }

  return String(text || '').replace(/[\s\u00a0]+/g, '') !== ''
}

export default hasRemarksText
